import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import Container from 'react-bootstrap/Container';
import { Server_URL } from "../config.js";
import { GoTopBtn } from '../components/GoTopBtn';
import './ListingProducts.css';

function ListingSensors() {
  const [sensors, setSensors] = useState([]);
  const [deleted, setDeleted] = useState(true)
  const [keyin, setKeyin] = useState([]);
  const PdfDrawing = 'SensorDrawing,';
  const PdfSpec = 'SensorSpec,';
  const navigate = useNavigate();

  // console.log('into ListingSensors()');
  useEffect(() => {
    if (deleted) {
      console.log('into ListingSensors() ', `${Server_URL}/show_sensors`);
      setDeleted(false)
      axios
        .get(`${Server_URL}/show_sensors`)
        .then((res) => { setSensors(res.data) })
        .catch((err) => console.log(err))
    }
  }, [deleted])

  return (
    // <div className='container-fluid bg-primary vh-100 vw-100'>
    // <div className='container-fluid'>
    <Container fluid className='listingsensor'>
      {/* <br /> */}
      <div> <h2 className='text-center'>Sensor List</h2> </div>
      {/* <div> <h1 className='listingsensor'> </h1> </div> */}
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder=" eg. 10.1, 15.0,..." value={keyin} onChange={(e) => setKeyin(e.target.value)} />
        <Link to={`/ListingSensorsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Sensor Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
        {/* <Link to='/ListingSensors' className='btn btn-success mx-2'>Add Sensor</Link> */}
        {/* <button className='btn trbtn-success' onClick={() => navigate(`/ShowSensorsSize/${keyin}`)}>Sensor Size</button> */}
      </div>
      <br />
      <h3 className='text-center'>Sensor All</h3>
      <table>
        <thead className='text-center bg-success-subtle'>
          <tr>
            <th>SNo</th> <th>Size</th> <th>-PartNo-</th> <th>Ratio</th>
            <th>-SensorOD-</th> <th>-SensorAA-</th> <th>SGThick</th>
            <th>-CoverVA-</th>
            <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
            <th>-RegDate-</th> <th>-Draw-</th>
            <th>-Actions-</th>
          </tr>
        </thead>

        <tbody className='text-center bg-primary-subtle'> {
          sensors.map((sensor, i) => {
            return (
              <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
                <td>{sensor.SNo}</td> <td>{sensor.Size}</td> <td>{sensor.PartNo}</td> <td>{sensor.Ratio}</td>
                <td>{sensor.SensorOD}</td> <td>{sensor.SensorAA}</td> <td>{sensor.SensorThick}</td>
                <td>{sensor.CoverVA}</td>
                <td>{sensor.ChannelRxTx}</td> <td>{sensor.ControlCard}</td>
                <td>{sensor.RegistDate}</td> <td>{sensor.DrawYes}</td>
                <td>
                  <Link to={`/ShowSensorDetail/${sensor.SNo}`} className='btn trbtn-success'>Read</Link>
                  <Link to={`/ViewPDF/${PdfDrawing + sensor.PartNo}`} className='btn trbtn-success m-1'>Drawing</Link>
                  <Link to={`/ViewPDF/${PdfSpec + sensor.PartNo}`} className='btn trbtn-success'>Spec</Link>
                </td>
              </tr>
            )
          })
        } </tbody>
      </table>
      <br />
      <div className='d-flex justify-content-center'>
        <label className='p-1 fs-5'><b>Size : </b></label>
        <input type="text20" placeholder=" eg. 8.0, 21.5..." value={keyin} onChange={(e) => setKeyin(e.target.value)} />
        <Link to={`/ListingSensorsBySize/${keyin}`} className='btn btn-success mx-2 fs-5'>Select Sensor Size</Link>
        <button className='btn btn-success fs-5' onClick={() => navigate(-1)}>Back</button>
      </div>
      <div> < GoTopBtn /> </div>
    </Container>
  )
}

export default ListingSensors;

// function handleDelete(id) {
//   axios
//     .delete(`${Server_URL}/delete_sensor/${id}`)
//     // .delete(`http://localhost:3022/delete_sensor/${id}`)
//     .then((res) => { setDeleted(true) })
//     .catch((err) => console.log(err))
// }

// axios
//   .get(`${Server_URL}/show_sensors`)
//   .then((res) => { setSensors(res.data) })
//   .catch((err) => console.log(err))
// // .get(`${Server_URL}/get_sensors_size/All`)
// // .get('http://localhost:3022/show_sensors')
// // .then((res) => { setSensors(res.data); console.log(sensors); })

// <thead className='text-center bg-success-subtle'>
// {/* <thead className='m-1 px-1 fs-6 text-center bg-success-subtle'> */}
//   <tr>
//     <th>SNo</th> <th>Size</th> <th>-----PartNo-----</th> <th>Ratio</th>
//     <th>---SensorOD----</th> <th>--SensorAA--</th> <th>SGThick</th>
//     <th>---CoverVA----</th>
//     <th>-ChnRxTx-</th> <th>-CtrlCard/IC-</th>
//     <th>FPCLocation，</th> <th>ScreenPartNo，</th> <th>CustomerPartNo，</th>
//     <th>--RegDate--</th> <th>--Draw--</th>
//     <th>--RegDate--</th> <th>---Note---</th> <th>--Draw--</th>
//     <th>--------Actions--------</th>
//     <th>-Note-</th> <th>-Draw-</th> <th>-Actions-</th>
//     <th>--</th>
//   </tr>
// </thead>

// {/* <tbody className='px-1 fs-6 text-center bg-primary-subtle'> { */}
// console.log(" sensor.SNo :", sensor.SNo, " sensor.PartNo :", sensor.PartNo);
// <tbody className='text-center bg-primary-subtle'> {
//   sensors.map((sensor, i) => {
//     // console.log(" sensor.SNo :", sensor.SNo, " sensor.PartNo :", sensor.PartNo);
//     return (
//       <tr key={i++} className={(i % 2) ? "bg-success-primary" : 'bg-light'}>
//         {/* <td>{sensor.FpcLoc}</td> <td>{sensor.PrintPN}</td> <td>{sensor.CustomerPN}</td> */}
//         {/* <td>{sensor.RegistDate}</td> <td>{sensor.Note}</td> <td>{sensor.DrawYes}</td> */}
//         {/*
//         <td>
//           <Link to={`/ShowSensorDetail/${sensor.SNo}`} className='btn trbtn-success p-1'>Read</Link>
//           <Link to={`/ViewPDF/${PdfDrawing + sensor.PartNo}`} className='btn trbtn-success m-1 p-1'>Drawing</Link>
//           <Link to={`/ViewPDF/${PdfSpec + sensor.PartNo}`} className='btn trbtn-success p-1'>Spec</Link>
//         </td>
//         */}
//       </tr>
//     )
//   })
// } </tbody>
